<template>
  <div class="thumb" ref="thumb" @click="setFeature" role="button" tabindex="0" aria-label="product thumbnail">
    <div :class="badge">
      <img :src="img1x" :srcset="img2x" :alt="alt">
      <span v-show="caption">{{ caption }}</span>
      <div v-if="video" class="btn-wrapper"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'photo',

    props: {
      src: { 
        required: true,
        type: String
      },
      src2: {
        required: true,
        type: String
      },
      alt: {
        type: String,
        default: "Product thumbnail"
      },
      video: {
        type: Boolean,
        default: false
      },
      caption: {
        type: String
      },
      badge: {
        required: false,
        type: String
      },
      id: {
        required: false,
        type: String
      }
    },

    computed: {
      img1x() {
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + this.src;
      },

      img2x() {
        return "https://s3.amazonaws.com/s3.pilates.com/contrology/" + this.src2 + ' 2x';
      }
    },

    methods: {
      setFeature() {
        this.$emit('setFeature', this.$refs.thumb.innerHTML);
        if (this.video) {
          this.$emit('isVideo');
        }
        if (this.id) {
          this.$emit('setId', this.id);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.btn-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 45px;
  height: 45px;
  transform: translate(-50%, -50%);
  border-radius: 22px;
  border: 5px solid var(--white);
  cursor: pointer;
}

.btn-wrapper::after {
  content: '';
  width: 0;
  height: 0;
  font-size: 0;
  line-height: 0;
  border-top: 9px solid transparent;
  border-left: 13px solid #fff;
  border-bottom: 9px solid transparent;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-30%, -50%);
}

.photo-grid img {
  width: 100%;
  display: block;
  cursor: pointer;
}

.photo-grid span {
  display: none;
}

.thumb {
  position: relative;
}

.new::after {
  content: "NEW";
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 10px;
  left: 10px;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid var(--white);
  background-color: var(--black);
  color: var(--white);
  font-size: 0.5rem;
}
</style>
